document.addEventListener("DOMContentLoaded", () => {
  console.clear();

  // Select the circle element (custom cursor)
  const circleElement = document.querySelector('.circle');
  console.log(circleElement); // Check if the circle element is correctly selected

  // Check if circleElement exists
  if (!circleElement) {
    console.error("Circle element not found!");
    return;
  }

  // Select hoverable elements (links, images, buttons, etc.)
  const hoverElements = document.querySelectorAll(
    'a, img, button, input, textarea, .jdgm-popup-card__close-btn, .jdgm-popup-card, .cursor-target, .js, .card, .header__icon, .accordion__title, .icon-accordion, .related-products, .facets__wrapper, .facet-filters__field, #ProductCountDesktop, .marquee-text'
  );

  hoverElements.forEach((el) => {
    el.addEventListener('mouseenter', () => {
      circleElement.classList.add('hovering');
    });

    el.addEventListener('mouseleave', () => {
      circleElement.classList.remove('hovering');
    });
  });

  // Create objects to track mouse position and custom cursor position
  const mouse = { x: 0, y: 0 };
  const previousMouse = { x: 0, y: 0 };
  const circle = { x: 0, y: 0 };

  let currentScale = 0;
  let currentAngle = 0;

  // Update mouse position on 'mousemove'
  window.addEventListener('mousemove', (e) => {
    mouse.x = e.x;
    mouse.y = e.y;
  });

  // FASTER speed for Mac
  const speed = 0.45;
  const pixelRatio = window.devicePixelRatio || 1;

  // Animation loop for cursor movement
  const tick = () => {
    const deltaX = mouse.x - circle.x;
    const deltaY = mouse.y - circle.y;

    // Normal movement with smooth easing
    circle.x += deltaX * speed;
    circle.y += deltaY * speed;

    const translateTransform = `translate(${circle.x}px, ${circle.y}px)`;

    // Adjust for devicePixelRatio for cross-device consistency
    const deltaMouseX = (mouse.x - previousMouse.x) / pixelRatio;
    const deltaMouseY = (mouse.y - previousMouse.y) / pixelRatio;
    previousMouse.x = mouse.x;
    previousMouse.y = mouse.y;

    // Less aggressive velocity and scale for better cross-device consistency
    const mouseVelocity = Math.min(Math.sqrt(deltaMouseX ** 2 + deltaMouseY ** 2) * 2, 70);
    const scaleValue = (mouseVelocity / 70) * 0.3;
    currentScale += (scaleValue - currentScale) * speed;
    const scaleTransform = `scale(${1 + currentScale}, ${1 - currentScale})`;

    const angle = Math.atan2(deltaMouseY, deltaMouseX) * 180 / Math.PI;
    if (mouseVelocity > 10) {
      currentAngle = angle;
    }
    const rotateTransform = `rotate(${currentAngle}deg)`;

    circleElement.style.transform = `${translateTransform} ${rotateTransform} ${scaleTransform}`;
    window.requestAnimationFrame(tick);
  };

  tick();
});